import {HttpServices} from '../Helpers';
import {PHP_V13_URL} from '../api/urls';

export const GetAllSetupsCommittees = async ({
    limit,
    page,
    search,
    committee_type,
    status = true,
    use_for = 'dropdown',
    with_than,
    other_than
}) => {
    const queryList = [];
    if (limit || limit === 0) queryList.push(`limit=${limit}`);
    if (page || page === 0) queryList.push(`page=${page}`);
    if (search) queryList.push(`query=${search}`);
    if (committee_type || committee_type === 0)
        queryList.push(`type=${committee_type}`);
    if (status) queryList.push(`status=${status}`);
    if (use_for) queryList.push(`use_for=${use_for}`);

    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/setup/${
            process.env.REACT_APP_VERSION_API
        }/organizational/committee?${queryList.join('&')}`,
        {
            params: {with_than, other_than},
        },
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};
